import { render, staticRenderFns } from "./MainDisplay.vue?vue&type=template&id=6149ab27&scoped=true&"
import script from "./MainDisplay.vue?vue&type=script&lang=ts&"
export * from "./MainDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MainDisplay.vue?vue&type=style&index=0&id=6149ab27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149ab27",
  null
  
)

export default component.exports